export default __webpack_public_path__ + "static/media/TVS_Max_125_catalogo.1139bb73.pdf";